
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";


export default function Vpnr({vpn, position}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={vpn.photo !== null ? vpn?.photo : "/assets/imgs/blank.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{vpn?.nomuser}</div>
                        <div className="widget-subheading">{vpn?.email}</div>
                    </div>
                </div>
            </td>
            <td>{vpn?.username}</td>
            {/* <td>{vpn?.mdp}</td> */}
            <td>{vpn.duree !== null ? vpn?.duree : ""}</td>
            <td>{vpn?.datedeb !== null ? vpn?.datedeb.slice(0, 16).replace("T", " à ") : ""}</td>
            <td>{vpn?.datefin !== null ? vpn?.datefin.slice(0, 16).replace("T", " à ") : ""}</td>
            <td>
                <span 
                    className={`badge ${
                        (vpn.etat === 1 && vpn.urltype === "vpns") ? "badge-warning" : 
                        (vpn.etat ===  1 && vpn.urltype === "comptevpns") ? "badge-success" : 
                        vpn.etat === 3 ? "badge-danger" : 
                        ""
                        } mt-2`
                    } 
                    style={{fontSize: 14}}>
                        {
                            vpn.etatdef !== null ? vpn?.etatdef : 
                            "Etat"
                        }
                </span>
            </td>
            <td>{vpn?.datecrea.slice(0, 16).replace("T", " à ")}</td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isConsulterCompteVPN) && vpn.urltype === "comptevpns" &&
                    <Link to={`/vpn/${vpn?.code}`} data-toggle="tooltip" title={textes.fr.viewcomptevpnlabel} data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                        <i className="fa fa-eye"></i>
                    </Link>
                }
            </td>
        </tr>
    )
}